var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0003 23.8333C7.01708 23.8333 2.16699 18.9832 2.16699 13C2.16699 7.01674 7.01708 2.16666 13.0003 2.16666C14.6823 2.16582 16.3413 2.55702 17.8457 3.30922C19.3501 4.06142 20.6585 5.15391 21.667 6.49999H18.7312C17.4802 5.3969 15.9374 4.67821 14.2881 4.43017C12.6388 4.18214 10.9529 4.41528 9.43279 5.10164C7.91268 5.78799 6.6229 6.8984 5.71823 8.29961C4.81357 9.70082 4.33243 11.3333 4.33257 13.0012C4.33271 14.6691 4.81412 16.3015 5.71902 17.7025C6.62392 19.1036 7.91388 20.2138 9.4341 20.8999C10.9543 21.586 12.6402 21.8189 14.2895 21.5705C15.9388 21.3222 17.4814 20.6033 18.7322 19.5H21.6681C20.6595 20.8462 19.3509 21.9388 17.8463 22.691C16.3417 23.4432 14.6825 23.8343 13.0003 23.8333ZM20.5837 17.3333V14.0833H11.917V11.9167H20.5837V8.66666L26.0003 13L20.5837 17.3333Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.245a2f1b19ea5503166301cfe7ffc3be.svg";
export { ForwardRef as ReactComponent };